import * as React from "react";
import { Logo, Text } from "@/src/components";
import { ComponentPage } from "@/components/docs/component-page";

export default function DocsComponentsLogo() {
  const code = `import Logo from "@/registry/new-york/ui/brand-logo";

export function LogoDemo() {
  return (
    <div className="flex items-center gap-2">
      <Logo size={32} title="Logo" />
      <Text className="text-h5 font-bold">bluecopa</Text>
    </div>
  );
}`;

  const installCommand = `npx shadcn@latest add @bluecopa-ui/logo`;

  return (
    <ComponentPage
      title="Logo"
      description="Inline SVG brand logo component with customizable colors and dimensions."
      preview={
        <div className="flex items-center gap-2">
          <Logo size={32} title="Logo" />
          <Text className="text-h5 font-bold">bluecopa</Text>
        </div>
      }
      code={code}
      installCommand={installCommand}
      apiReference={{
        name: "LogoProps",
        props: [
          {
            name: "size",
            type: "number | string",
            description: "Default size for both width and height. Defaults to 24.",
          },
          {
            name: "width",
            type: "number | string",
            description: "Custom width (overrides size).",
          },
          {
            name: "height",
            type: "number | string",
            description: "Custom height (overrides size).",
          },
          {
            name: "className",
            type: "string",
            description: "Additional CSS classes.",
          },
          {
            name: "title",
            type: "string",
            description: 'Accessible title for the logo. Defaults to "Logo".',
          },
          {
            name: "primary",
            type: "string",
            description: "Primary brand color (big right shape). Defaults to CSS variable.",
          },
          {
            name: "secondary",
            type: "string",
            description: "Secondary brand color (big left shape). Defaults to CSS variable.",
          },
          {
            name: "contrast",
            type: "string",
            description: 'Contrast color (inner circles). Defaults to "#fff".',
          },
        ],
      }}
    />
  );
}

